<template>
  <OCollapse
    animation="slide"
    :open="show"
    :class="[
      'ucrs-accordion--noBorderTop ucrs-accordion--noBorderBottom',
      'w-full bg-gray-lightest shadow-inner',
      {
        'lg:mb-8': show,
      },
    ]"
    content-class="max-h-32"
  >
    <div :id="regionId" class="container" role="region">
      <p
        class="h-32 flex items-center justify-around md:justify-between mx-auto max-w-screen-sm"
      >
        <a
          v-for="item of services"
          :key="item.icon"
          rel="nofollow"
          target="_blank"
          :href="item.url"
          :class="[
            'flex items-center font-bold text-sm uppercase h-full',
            item.class,
          ]"
          :data-action="item.dataAction"
        >
          <!--
            h-full because if not present the svg overflows the parent
            and it is visible on focus
          -->
          <SvgIcon :name="item.icon" class="w-10 md:mr-3 h-full" />
          <span class="hidden md:block">{{ item.name }}</span>
        </a>
      </p>
    </div>
  </OCollapse>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    regionId: {
      type: String,
      default: null,
    },
  },

  computed: {
    shareUrl() {
      const shareUrl = this.$config.baseURL + this.$route.fullPath
      return encodeURIComponent(shareUrl)
    },

    services() {
      const { shareUrl } = this

      if (!shareUrl) {
        return
      }

      const services = [
        {
          name: 'Facebook',
          icon: 'facebook',
          url: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
          class: 'text-black',
        },
        {
          name: 'Whatsapp',
          icon: 'whatsapp',
          url: `whatsapp://send?text=${shareUrl}`,
          class: 'text-black',
          dataAction: 'share/whatsapp/share',
        },
        {
          name: 'Twitter',
          icon: 'twitter-x',
          url: `https://twitter.com/home?status=${shareUrl}`,
          class: 'text-black',
        },
        {
          name: 'LinkedIn',
          icon: 'linkedin',
          url: `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}`,
          class: 'text-black',
        },
      ]

      return services
    },
  },
}
</script>
